import { useContext, useEffect } from 'react';

import { OptimizelyContext } from '@optimizely/react-sdk';

import { ConfigContext } from 'Context/config';
import { UserContext } from 'Context/user';

import { optimizelyAttributes as defaultAttributes } from 'Utilities/analytics/optimizely/optimizely.helper';

const ON = 'on';
const OFF = 'off';

type useBinaryExperimentOptions = Partial<{
  offKey: string;
  onKey: string;
  overrideAttributes: Record<string, string | number>;
  triggerExperiment: boolean;
}>;

export const useBinaryExperiment = (flag: string, {
  offKey = OFF,
  onKey = ON,
  overrideAttributes = undefined,
  triggerExperiment = false,
}: useBinaryExperimentOptions = { offKey: OFF, onKey: ON, triggerExperiment: true }) => {
  const { optimizely } = useContext(OptimizelyContext);
  const { configState: { experimentDecisions } } = useContext(ConfigContext);
  const { userState: user } = useContext(UserContext);
  const experimentVariant = experimentDecisions?.[flag] ?? offKey;
  const userId = user?.id;

  useEffect(() => {
    if (!triggerExperiment) {
      return;
    }

    optimizely?.onReady().then(() => {
      if (experimentDecisions?.[flag]) {
        optimizely.decide(flag, undefined, undefined, defaultAttributes({ userId, ...overrideAttributes }));
      }
    });
  }, [experimentDecisions, optimizely, flag, triggerExperiment, userId, overrideAttributes]);

  return experimentVariant === onKey;
};
